var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2UserProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 50.46V57H17v-6.93A9.07 9.07 0 0126.07 41h23.21A9.61 9.61 0 0159 50.46zM38 36a10 10 0 100-20 10 10 0 000 20z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_User_profile.22cdc646.svg";
export { SvgJ2UserProfile as ReactComponent };